import { Form, Formik, useField } from "formik"

//PrimeReact
import { Panel } from "primereact/panel"
import { Rating } from "primereact/rating"

//Styles
import styles from "../../../styles/Form-Inputs.module.css"

//Referral components
import RefTextAreaInput from "../../Partner/Components/Input/RefTextAreaInput"

export default function ReferralRating({ rating, isLoading }) {
  function GetRating({ name, disabled }) {
    // eslint-disable-next-line no-unused-vars
    const [field] = useField(name)

    let ratingDescription = ""

    switch (field.value) {
      case 1:
        ratingDescription = "Very dissatisfied"
        break
      case 2:
        ratingDescription = "Dissatisfied"
        break
      case 3:
        ratingDescription = "Neither satisfied nor dissatisfied"
        break
      case 4:
        ratingDescription = "Satisfied"
        break
      case 5:
        ratingDescription = "Very satisfied"
        break
      default:
        ratingDescription = ""
    }

    return (
      <div
        className={styles.field}
        style={{ height: "100%", marginTop: "10px" }}
      >
        <label>{`Satisfaction rating:  ${ratingDescription}`}</label>
        <div style={{ height: "100%", marginTop: "10px" }}>
          <Rating {...field} cancel={false} disabled={disabled}></Rating>
        </div>
      </div>
    )
  }

  if (!rating || rating.id === 0) {
    return null
  } else {
    return (
      <Panel
        header="Participant feedback"
        style={{ marginBottom: "10px", marginTop: "10px" }}
        className="p-fluid"
      >
        <Formik initialValues={rating} enableReinitialize onSubmit={() => {}}>
          {({ handleSubmit }) => (
            <Form onSubmit={handleSubmit} autoComplete="off">
              <GetRating name={"score"} disabled={true} />
              <div style={{ width: "100%" }}>
                <RefTextAreaInput
                  name="note"
                  label="Note"
                  style={{ width: "100%" }}
                  disabled={true}
                />
              </div>
            </Form>
          )}
        </Formik>
      </Panel>
    )
  }
}
